/**
 * Textos que usa el código y que pueden no existir en `languages/{id}/keyValuePairs`.
 * Se aplican por debajo de la base de datos: si la clave existe allí, gana la base de datos.
 * Al agregar una clave nueva con t('...'), agrégala aquí en es y en.
 */
const es = {
  // Tablas y formularios (web)
  visible_in_app: 'Visible en la app',
  Email: 'Correo',
  Nombre: 'Nombre',
  Telefono: 'Teléfono',
  Necki: 'Nequi',
  Bancolombia: 'Bancolombia',
  Docs: 'Documentos',
  update: 'Actualizar',
  invalid_userType_add: 'No se puede crear un usuario de ese tipo.',
  'User Type': 'Tipo de usuario',
  'Email Id': 'Correo',
  Password: 'Contraseña',
  list: 'Listado',
  Description: 'Descripción',
  goto: 'Ir al perfil',

  // Referidos
  master_code_colon: 'Código de referido: ',
  inviter_code_optional: 'Código de quien te invitó (opcional)',
  link_copied: 'Enlace copiado al portapapeles',
  profile_referral_link_section: 'Tu enlace de referido',
  referral_block_hint: 'Copia el enlace o comparte el mensaje con tu código.',
  copy_link: 'Copiar enlace',
  share_referral_link: 'Compartir enlace',
  share_via_social: 'Compartir en redes y mensajes',
  share_via_social_hint: 'Elige una red; se abrirá en una nueva pestaña con tu mensaje y enlace.',
  share_whatsapp: 'WhatsApp',
  share_facebook: 'Facebook',
  share_twitter: 'X (Twitter)',
  share_telegram: 'Telegram',
  share_linkedin: 'LinkedIn',
  share_email: 'Correo',
  share_sms: 'SMS',
  share_more: 'Más opciones del sistema',
  referrals_not_loaded_abbr: '—',
  referral_level_1: 'NIVEL 1',
  referral_level_2: 'NIVEL 2',
  referral_level_3: 'NIVEL 3',
  referral_level_1_hint: 'Referidos directos (nivel 1)',
  referral_level_2_hint: 'Total nivel 2 (pulsa para cargar). «—» = aún no cargado.',
  referral_level_3_hint: 'Total nivel 3 (pulsa para cargar). «—» = aún no cargado.',
  search_referrals_placeholder: 'Buscar por nombre, email o teléfono...',
  wallet_bal_low_b: 'Saldo insuficiente. Necesitas al menos COP$ 100.000 para retirar.',

  // Billetera
  Credit: 'DEPÓSITO',
  Debit: 'DÉBITO',
  Withdraw: 'RETIRO',
  Skipped: 'OMITIDO',

  // Notificaciones push (móvil)
  recovery_successful: 'Recuperación exitosa',
  notifications_recovered: '¡Perfecto! Tus notificaciones han sido recuperadas.',
  recovery_stats_title: 'Estadísticas de recuperación',
  successful_recoveries: 'Recuperaciones exitosas',
  failed_recoveries: 'Recuperaciones fallidas',
  success_rate: 'Tasa de éxito',
  last_attempt: 'Último intento',
  invalid_tokens: 'Tokens inválidos detectados',
  recovering: 'Recuperando...',
  notifications_updated_title: 'Notificaciones actualizadas',
  notifications_updated_message: 'Tus notificaciones push se actualizaron automáticamente para que recibas todos los mensajes importantes.',
  push_required_to_go_online_title: 'Notificaciones requeridas',
  push_required_to_go_online: 'Activa las notificaciones para ponerte en línea y recibir solicitudes de viaje. Sin ellas no te llegarán viajes con la pantalla apagada.',
  push_required_open_settings: 'Abrir ajustes',
  push_disabled_went_offline: 'Te pusimos fuera de línea porque no hay notificaciones push activas. Actívalas e inténtalo de nuevo.',
  regeneration_stats_title: 'Estadísticas de regeneración',
  total_regenerations: 'Regeneraciones totales',
  last_check: 'Última verificación',
  os_version: 'Versión del sistema',
  app_version: 'Versión de la app',

  // Viajes, pagos y errores (móvil)
  cannot_exit_active_ride: 'No puedes salir mientras tienes un viaje activo.',
  inactive: 'Inactivo',
  email_phone: 'Agrega un correo o un teléfono en tu perfil para poder enviar la queja.',
  something_went_wrong: 'Algo salió mal. Intenta de nuevo.',
  chat_error: 'No se pudo cargar el chat. Intenta de nuevo.',
  chat_empty_title: 'Aún no hay mensajes',
  chat_empty_hint: 'Escribe para coordinar el punto de encuentro.',
  chat_empty_locked: 'Este viaje ya finalizó. El chat está cerrado.',
  chat_not_found: 'No se pudo enviar el mensaje. Intenta de nuevo.',
  chat_send_failed: 'No se pudo enviar. Puedes tocar el mensaje para reintentar.',
  chat_tap_retry: 'Toca para reintentar',
  chat_input_title: 'Escribe un mensaje…',
  chat_title: 'Chat del viaje',
  chat_blank: 'Escribe algo…',
  today_text: 'Hoy',
  not_chat: 'El chat no está disponible.',
  not_call: 'No puedes llamar ahora.',
  booking_is: 'El viaje está ',
  call_unavailable_completed: 'Este viaje ya finalizó. No puedes llamar.',
  call_unavailable_cancelled: 'Este viaje fue cancelado. No puedes llamar.',
  chat_locked_placeholder: 'No puedes enviar mensajes',
  retry: 'Reintentar',
  off_route_driver_title: 'Saliste de la ruta',
  off_route_driver_hint: 'Recalculando el camino. El pasajero verá la ruta nueva en unos segundos.',
  off_route_rider_title: 'El conductor salió de la ruta',
  off_route_rider_hint: 'Estamos actualizando el camino y el tiempo estimado.',
  calculating_route: 'Calculando ruta…',
  round_trip_map_badge: 'Ida · Vuelta',
  round_trip_leg_outbound: 'IDA',
  round_trip_leg_return: 'VUELTA',
  round_trip_return_started: 'Ida completada. Ahora regresa al punto de origen.',
  round_trip_confirm_msg: 'Está seleccionando viaje de IDA y VUELTA',
  min_fare_distance: 'Km en mínima',
  complete_outbound: 'Llegué al destino (ida)',
  complete_return: 'Finalizar regreso',
  stop: 'parada',
  stops: 'paradas',
  nequi_on_delivery: 'PAGO CON NEQUI AL LLEGAR',
  pay_nequi: 'CONFIRMAR PAGO NEQUI',
  bank_on_delivery: 'TRANSFERENCIA AL LLEGAR',
  pay_bank: 'CONFIRMAR TRANSFERENCIA',
  pay_cash: 'CONFIRMAR PAGO EN EFECTIVO',
  cash_on_delivery: 'PAGO EN EFECTIVO AL LLEGAR',
  confirm_payment_subtitle: 'Confirma el monto y completa tu pago',
  driver_confirm_payment_title: 'Confirma el pago',
  driver_confirm_payment_subtitle: 'Verifica cómo te pagan y confirma que ya recibiste el dinero',
  payment_method: 'Método de pago',
  how_you_get_paid: 'Cómo te pagan',
  pay_mode_cash: 'Efectivo',
  pay_mode_nequi: 'Nequi',
  pay_mode_bank: 'Transferencia bancaria',
  pay_mode_wallet: 'Billetera',
  pay_mode_card: 'Tarjeta',
  driver_pay_hint_cash: 'El pasajero te paga en efectivo. Cuenta el dinero y confirma solo cuando lo tengas en mano.',
  driver_pay_hint_nequi: 'El pasajero te envía el valor por Nequi. Revisa tu app y confirma solo cuando veas el abono.',
  driver_pay_hint_bank: 'El pasajero te hace una transferencia. Verifica el depósito en tu cuenta y luego confirma.',
  driver_pay_hint_wallet: 'El pago se descuenta de la billetera del pasajero. Confirma para cerrar el viaje.',
  driver_pay_hint_card: 'El cobro se procesa con tarjeta. Confirma para completar el viaje.',
  driver_confirm_received: 'Confirma que recibiste el pago antes de continuar',
  driver_confirm_cash_btn: 'Confirmo que recibí el efectivo',
  driver_confirm_nequi_btn: 'Confirmo que recibí el pago por Nequi',
  driver_confirm_bank_btn: 'Confirmo que recibí la transferencia',
  driver_your_account: 'Tu cuenta para recibir',
  bankName: 'Banco',
  bankAccount: 'Número de cuenta',
  bankCode: 'Tipo / código',
  passenger: 'Pasajero',
  amount_to_collect: 'Monto a cobrar',
  driver_share: 'Tu ganancia',
  customer_confirm_trip_title: 'Confirma tu viaje',
  customer_confirm_trip_subtitle_later: 'Acordaste el precio. Pagarás al llegar con {method}.',
  customer_confirm_trip_subtitle_now: 'Paga ahora para confirmar al conductor.',
  offer_accepted: 'Oferta aceptada',
  agreed_price: 'Precio acordado',
  your_offer: 'Tu oferta',
  customer_pay_hint_cash: 'Le pagarás en efectivo al conductor al finalizar el viaje.',
  customer_pay_hint_nequi: 'Le enviarás el pago por Nequi al finalizar el viaje.',
  customer_pay_hint_bank: 'Le harás la transferencia al finalizar el viaje.',
  customer_pay_hint_wallet: 'Se descuenta de tu billetera al confirmar.',
  customer_pay_hint_card: 'Se cobra con tu tarjeta al confirmar.',
  customer_confirm_cash_btn: 'Confirmar viaje · Efectivo al llegar',
  customer_confirm_nequi_btn: 'Confirmar viaje · Nequi al llegar',
  customer_confirm_bank_btn: 'Confirmar viaje · Transferencia al llegar',
  customer_confirm_pay_now_btn: 'Pagar y confirmar viaje',
  vehicle_arrived_title: 'Tu vehículo llegó',
  vehicle_arrived_hint: 'Identifícalo por la placa, marca y color antes de subir.',
  vehicle_color: 'Color',
  vehicle_color_required: 'El color del vehículo es obligatorio.',
  vehicle_make: 'Marca',
  vehicle_model: 'Modelo',
  vehicle_number: 'Placa',
  registration_card: 'Tarjeta de propiedad',
  upload_registration_image: 'Sube la foto de la tarjeta de propiedad',
  registration_image_required: 'Debes subir la imagen de la tarjeta de propiedad.',
  view_registration: 'Matrícula / propiedad',
  car_photo_tip: 'Sube buenas fotos de tu vehículo',
  registration_photo_tip: 'Sube una imagen clara de la matrícula',
  verify_id: 'Número Documento ID/Cédula',
  verifyid_image: 'Imagen Documento ID/Cédula',
  upload_verifyIdImage: 'Sube la imagen de tu documento ID/cédula',
  verified_badge: 'Verificado',
  driver_arriving_title: 'Tu conductor está llegando',
  driver_arriving_msg: 'Prepárate, tu conductor está a menos de un minuto.',
  arrival_horn_setting: 'Sonido de llegada del conductor',
  arrival_horn_setting_hint: 'Claxon cuando tu conductor está a menos de un minuto',
  id_verify_optional_hint:
    'La verificación es opcional. Si estás verificado puedes participar en bonos, promociones y regalos en Conecta2. Puedes pedir viajes sin verificar.',
  id_verify_driver_required_hint:
    'Debes subir tu documento ID/cédula para poder operar como conductor.',
  documents_menu_subtitle:
    'Si estás verificado puedes participar en bonos, promociones y regalos en Conecta2.',
  driving_license_font: 'Frente Licencia Conducir',
  driving_license_back: 'Dorso Licencia Conducir',
  upload_driving_license: 'Sube tu licencia de conducir',
  upload_driving_license_front: 'Sube el frente de tu licencia de conducir',
  upload_driving_license_back: 'Sube el dorso de tu licencia de conducir',
  documents: 'Documentos',
  creating_new_request: 'Creando nueva solicitud…',
  request_no_longer_available: 'Esta solicitud ya no está disponible. Otro conductor la tomó o el pasajero canceló.',
  request_timeout_message: 'Se agotó el tiempo de espera. No encontramos un conductor. ¿Quieres intentar de nuevo?',
  car_rejected: 'Rechazado',
  car_rejected_title: 'Vehículo rechazado',
  car_rejected_hint: 'Corrige lo indicado y vuelve a enviar para aprobación.',
  car_resubmit: 'Reenviar para aprobación',
  car_reject: 'Rechazar',
  car_approve: 'Aprobar',
  car_reject_title: 'Rechazar vehículo',
  car_reject_pick_reason: 'Elige el motivo del rechazo',
  car_reject_other_placeholder: 'Describe el motivo…',
  car_reject_confirm: 'Confirmar rechazo',
  got_it: 'Entendido',
  customer_otp_title: 'Código del viaje',
  customer_otp_hint: 'Dile este código al conductor para iniciar el viaje.',
  payment_error: 'No se pudo procesar el pago. Intenta de nuevo.',
  error: 'Error',
  conversion_error: 'No se pudo cambiar el tipo de cuenta. Intenta de nuevo.',
  error_boundary_message: 'La app tuvo un error inesperado. Si continúa, ciérrala y vuelve a abrirla.',
  retry: 'Reintentar',

  // Registro con zonificación y red
  reg_error: 'No se pudo completar el registro. Intenta de nuevo.',
  signup_err_slots_full: 'Ya no quedan cupos especiales en esta ciudad. Regístrate con el código de referido de un conductor.',
  signup_err_network_slots_full: 'Tu patrocinador ya usó sus 50 cupos directos.',
  signup_err_network_level: 'Este conductor está en el nivel 3 y no puede invitar más conductores a la red.',
  signup_err_city_mismatch: 'Tu ciudad debe ser la misma de tu patrocinador.',
  signup_err_referrer_not_found: 'No encontramos al patrocinador de ese código.',
  signup_err_city_code_required: 'Ingresa el código de zonificación de tu ciudad.',
  signup_err_referral_code_required: 'Ingresa el código de referido de un conductor.',
  signup_err_city_required: 'Selecciona tu ciudad.',
  signup_err_city_inactive: 'Esta ciudad no está habilitada para registros por ahora.',
  signup_err_invalid_code: 'El código no es válido para esta ciudad.',
  signup_err_code_used: 'Este código ya fue utilizado.',
  signup_err_claim_failed: 'No pudimos reservar tu cupo. Intenta de nuevo.',
  signup_err_city_code_needs_driver: 'Ese es un código de ciudad. Debes registrarte como Conductor.',
  signup_err_city_code_needs_city: 'Ese es un código de ciudad. Selecciona la ciudad correcta (ej. Barranquilla) e inténtalo de nuevo.',
  join_conecta2: 'Únete a Conecta2',
  city: 'Ciudad',
  admin_contact_hint: 'Tu cuenta está en revisión. Te avisaremos cuando esté lista.',

  // Términos y Privacidad — verificación de identidad (Ley 1581 / Colombia)
  term_condition_heading13: 'Verificación de identidad y documentos (opcional):',
  term_condition_para15:
    'La verificación de identidad es opcional para los pasajeros. Conecta2 podrá solicitarle el número de su documento de identidad (cédula u otro documento válido) y una imagen o fotografía del mismo. Si usted decide cargar dichos datos, declara que son verdaderos, le pertenecen y autoriza su tratamiento para verificar su identidad, prevenir fraude, cumplir políticas internas de seguridad y, cuando corresponda, habilitar beneficios asociados a la cuenta verificada (por ejemplo, bonos, promociones o regalos). No es obligatorio verificar su documento para solicitar viajes. La verificación es un proceso interno de la plataforma y no constituye autenticación oficial ante entidades estatales ni reemplaza trámites gubernamentales.',
  term_condition_para16:
    'Conecta2 podrá aprobar, rechazar o solicitar la nueva carga del documento. En caso de rechazo, se le informará el motivo a través de la aplicación. El uso de documentos falsos, alterados o de terceros podrá dar lugar a la suspensión o terminación de su cuenta, sin perjuicio de las acciones legales a que haya lugar. Para conductores, cuando la plataforma lo exija, la carga del documento podrá ser condición para operar. El tratamiento de estos datos se rige además por nuestra Política de Privacidad.',
  term_condition_para12:
    'Estos Términos y Condiciones se rigen e interpretan de conformidad con las leyes de la República de Colombia. Cualquier controversia se someterá a los jueces y tribunales competentes del domicilio del responsable del Servicio en Colombia, sin perjuicio de normas imperativas de protección al consumidor que resulten aplicables.',

  privacy_policy_heading_id_docs: 'VERIFICACIÓN DE DOCUMENTO DE IDENTIDAD',
  privacy_policy_id_docs_para1:
    'De forma opcional para pasajeros (y cuando la configuración del Servicio lo exija para conductores), recopilamos y tratamos: (i) el número de documento de identidad (cédula u otro documento válido); y (ii) la imagen o fotografía del documento que usted carga en la aplicación. Estos datos se usan para verificar que la información coincide, validar su identidad, prevenir fraude, proteger la comunidad Conecta2, decidir la aprobación o rechazo de la verificación y, si aplica, habilitar beneficios como bonos, promociones o regalos asociados a la cuenta verificada. No es obligatorio para pasajeros a fin de solicitar viajes.',
  privacy_policy_id_docs_para2:
    'La base del tratamiento es su consentimiento al cargar el documento y/o la ejecución de la relación contractual con la plataforma. El acceso a la imagen y al número queda restringido al personal autorizado de Conecta2 encargado de la revisión. No publicamos su documento a otros usuarios ni lo usamos con fines de mercadeo.',
  privacy_policy_id_docs_para3:
    'Conservamos estos datos mientras su cuenta esté activa y por el tiempo adicional que resulte necesario para atender obligaciones legales, resolver controversias o prevenir abusos. Usted puede actualizar o volver a subir su documento desde la aplicación. Si la verificación es rechazada, se le mostrará el motivo para que pueda corregirlo.',
  privacy_policy_id_docs_para4:
    'De conformidad con la Ley 1581 de 2012 y normas complementarias (habeas data), usted puede solicitar acceso, actualización, rectificación o eliminación de sus datos personales, e informar el uso indebido, a través de los canales de contacto indicados en esta política. La eliminación de la imagen o del número de documento podrá limitar o impedir el uso de funciones que requieren verificación de identidad.',
  privacy_policy_heading_rights: 'DERECHOS DEL TITULAR (HABEAS DATA)',
  privacy_policy_rights_para1:
    'Como titular de datos personales en Colombia, usted tiene derecho a conocer, actualizar y rectificar su información; a solicitar prueba de la autorización; a ser informado sobre el uso de sus datos; a presentar quejas ante la Superintendencia de Industria y Comercio; a revocar la autorización y/o solicitar la eliminación de sus datos cuando proceda, salvo que exista un deber legal o contractual que impida su eliminación. Para ejercer estos derechos, contáctenos en el correo indicado más abajo.',
  privacy_policy_info_list8: 'Número de documento de identidad (cédula u otro documento válido)',
  privacy_policy_info_list9: 'Imagen o fotografía del documento de identidad cargada para verificación',
  privacy_policy_info_para3:
    'También podemos solicitar información sensible o de identificación cuando use o se registre en nuestra App, incluyendo datos necesarios para la verificación de identidad descritos en la sección «Verificación de documento de identidad».',
  privacy_policy_change_privacy_para2: 'Esta política está vigente a partir del 2026-10-12.',

  city_not_operational_for_drivers:
    'La ciudad aún no está operativa para conductores.',
  city_not_operational_for_drivers_named:
    'La ciudad {{city}} aún no está operativa para conductores.',
  convert_need_city_in_profile:
    'Para cambiar a conductor edita primero en qué ciudad te encuentras en tu perfil',
  edit_profile: 'Editar perfil',
  city_coming_soon_operational:
    'Pronto estaremos operativos en esta ciudad.',
  select_city_placeholder: 'Selecciona tu ciudad',
  select_city_first: 'Primero selecciona tu ciudad',
  city_label: 'Ciudad',
  zoning_code_placeholder: 'Código de zonificación',
  no_cities_configured: 'No hay ciudades configuradas',
  admin_must_create_cities: 'El administrador debe crear ciudades en Zonificación.',
  city_slots_full_hint: 'Ya no quedan cupos especiales: usa el código de referido de un conductor.',
  city_slots_open_hint: 'Cupos especiales abiertos: ingresa el código maestro o individual de tu ciudad.',

  offer_not_available: 'Esta oferta ya no está disponible. Elige otra.',
  tap_to_offer: 'Toca para mapa y ofertar',
  go_to_pickup: 'IR A RECOGER',
  confirm_arrival: 'CONFIRMAR LLEGADA',
  driver_journey_msg_started: 'El viaje ha iniciado, ponte el cinturón',
  driver_cancelled_booking_: 'El conductor canceló el servicio',
  driver_cancelled_booking: 'El conductor canceló el servicio',
  driver_cancelled_booking_detail: 'El conductor canceló el servicio. Puedes solicitar otro viaje.',
  customer_cancelled_booking_: 'El pasajero canceló el servicio',
  customer_cancelled_booking: 'El pasajero canceló el servicio',
  customer_cancelled_booking_detail: 'El pasajero canceló el servicio. Ya no debes continuar con este viaje.',
  rider_cancel_text: 'El pasajero canceló el servicio',
  request_timeout_reason: 'Tiempo de espera agotado',
  request_timeout_reason_: 'Tiempo de espera agotado',
  tiempo_de_espera_agotado_: 'Tiempo de espera agotado',
  request_timeout_message: 'Se agotó el tiempo de espera. No encontramos un conductor. ¿Quieres intentar de nuevo?',
  try_again: 'Intentar de nuevo',
  try_again_cta: 'Reintentar',
  exit: 'Salir',
  retry_booking_failed: 'No se pudo volver a solicitar el viaje. Intenta desde el mapa.',
  CANCELLED: 'Cancelado',
  COMPLETE: 'Completado',
  PAID: 'Pagado',
  NEW: 'Nuevo',
  ACCEPTED: 'Aceptado',
  no_name: 'Sin nombre',
  no_driver_assigned: 'Sin conductor asignado',
  driver: 'Conductor',

  // Código PIN del viaje (conductor)
  trip_pin_title_start: 'Código para iniciar el viaje',
  trip_pin_title_end: 'Código para finalizar el viaje',
  trip_pin_subtitle: 'Pídele al pasajero el código de {{digits}} dígitos que aparece en su app.',
  trip_pin_wrong: 'Código incorrecto. Verifícalo con el pasajero.',
  trip_pin_ok: 'Código verificado',
  trip_pin_verify: 'VERIFICAR',
  trip_pin_cancel: 'Cancelar',
  trip_pin_security: 'Este código confirma que llevas al pasajero correcto.',

  // Mis ganancias (conductor)
  daily: 'Diario',
  thisweek: 'Esta semana',
  thismonth: 'Este mes',

  // Panel web
  app_logs: 'Logs',
  loading_maps: 'Cargando mapas...',
  settings_not_found: 'No se pudo cargar la configuración. Recarga la página.',
  driver_assigned_notified: 'Conductor asignado y notificado.',

  // Acciones comunes
  no_address: 'No tienes direcciones guardadas.',
  no_complain: 'No hay quejas registradas.',
  email_or_mobile_issue: 'Por favor verifique su correo electrónico o número de teléfono móvil. Nota: El número de móvil debe estar en formato internacional (+57).',
  network_error_retry: 'No pudimos conectar con el servidor. Por favor verifica tu conexión a internet e inténtalo nuevamente.',
};

const en = {
  visible_in_app: 'Visible in app',
  Email: 'Email',
  Nombre: 'Name',
  Telefono: 'Phone',
  Necki: 'Nequi',
  Bancolombia: 'Bancolombia',
  Docs: 'Documents',
  update: 'Update',
  invalid_userType_add: "A user of that type can't be created.",
  'User Type': 'User type',
  'Email Id': 'Email',
  Password: 'Password',
  list: 'List',
  Description: 'Description',
  goto: 'Go to profile',

  master_code_colon: 'Referral code: ',
  inviter_code_optional: 'Inviter code (optional)',
  link_copied: 'Link copied to clipboard',
  profile_referral_link_section: 'Your referral link',
  referral_block_hint: 'Copy the link or share the message with your code.',
  copy_link: 'Copy link',
  share_referral_link: 'Share link',
  share_via_social: 'Share on social and messaging apps',
  share_via_social_hint: 'Pick a network; it opens in a new tab with your message and link.',
  share_whatsapp: 'WhatsApp',
  share_facebook: 'Facebook',
  share_twitter: 'X (Twitter)',
  share_telegram: 'Telegram',
  share_linkedin: 'LinkedIn',
  share_email: 'Email',
  share_sms: 'SMS',
  share_more: 'More system options',
  referrals_not_loaded_abbr: '—',
  referral_level_1: 'LEVEL 1',
  referral_level_2: 'LEVEL 2',
  referral_level_3: 'LEVEL 3',
  referral_level_1_hint: 'Direct referrals (level 1)',
  referral_level_2_hint: 'Level 2 total (tap to load). "—" = not loaded yet.',
  referral_level_3_hint: 'Level 3 total (tap to load). "—" = not loaded yet.',
  search_referrals_placeholder: 'Search by name, email or phone...',
  wallet_bal_low_b: 'Insufficient balance. You need at least COP$ 100,000 to withdraw.',

  Credit: 'CREDIT',
  Debit: 'DEBIT',
  Withdraw: 'WITHDRAWAL',
  Skipped: 'SKIPPED',

  recovery_successful: 'Recovery successful',
  notifications_recovered: 'Great! Your notifications have been recovered.',
  recovery_stats_title: 'Recovery statistics',
  successful_recoveries: 'Successful recoveries',
  failed_recoveries: 'Failed recoveries',
  success_rate: 'Success rate',
  last_attempt: 'Last attempt',
  invalid_tokens: 'Invalid tokens detected',
  recovering: 'Recovering...',
  notifications_updated_title: 'Notifications updated',
  notifications_updated_message: 'Your push notifications were updated automatically so you receive every important message.',
  push_required_to_go_online_title: 'Notifications required',
  push_required_to_go_online: 'Enable notifications to go online and receive trip requests. Without them you will miss rides when the screen is off.',
  push_required_open_settings: 'Open settings',
  push_disabled_went_offline: 'You were taken offline because push notifications are not active. Enable them and try again.',
  regeneration_stats_title: 'Regeneration statistics',
  total_regenerations: 'Total regenerations',
  last_check: 'Last check',
  os_version: 'OS version',
  app_version: 'App version',

  cannot_exit_active_ride: "You can't leave while you have an active ride.",
  inactive: 'Inactive',
  email_phone: 'Add an email or a phone number to your profile to send the complaint.',
  something_went_wrong: 'Something went wrong. Please try again.',
  chat_error: "The chat couldn't be loaded. Please try again.",
  chat_empty_title: 'No messages yet',
  chat_empty_hint: 'Write to coordinate the pickup point.',
  chat_empty_locked: 'This trip has ended. Chat is closed.',
  chat_not_found: "Couldn't send the message. Please try again.",
  chat_send_failed: "Couldn't send. Tap the message to retry.",
  chat_tap_retry: 'Tap to retry',
  chat_input_title: 'Type a message…',
  chat_title: 'Trip chat',
  chat_blank: 'Type something…',
  today_text: 'Today',
  not_chat: 'Chat is not available.',
  not_call: 'You cannot call right now.',
  booking_is: 'The trip is ',
  call_unavailable_completed: 'This trip has ended. You cannot call.',
  call_unavailable_cancelled: 'This trip was cancelled. You cannot call.',
  chat_locked_placeholder: 'You cannot send messages',
  off_route_driver_title: 'You left the route',
  off_route_driver_hint: 'Recalculating the path. The rider will see the new route in a few seconds.',
  off_route_rider_title: 'The driver left the route',
  off_route_rider_hint: 'Updating the path and estimated time.',
  calculating_route: 'Calculating route…',
  retry: 'Retry',
  round_trip_map_badge: 'Outbound · Return',
  round_trip_leg_outbound: 'OUTBOUND',
  round_trip_leg_return: 'RETURN',
  round_trip_return_started: 'Outbound complete. Now return to the origin.',
  round_trip_confirm_msg: 'You are selecting a ROUND TRIP (outbound and return)',
  min_fare_distance: 'Km included in minimum',
  complete_outbound: 'Arrived at destination (outbound)',
  complete_return: 'Finish return trip',
  stop: 'stop',
  stops: 'stops',
  nequi_on_delivery: 'PAY WITH NEQUI ON ARRIVAL',
  pay_nequi: 'CONFIRM NEQUI PAYMENT',
  bank_on_delivery: 'BANK TRANSFER ON ARRIVAL',
  pay_bank: 'CONFIRM BANK TRANSFER',
  pay_cash: 'CONFIRM CASH PAYMENT',
  cash_on_delivery: 'PAY CASH ON ARRIVAL',
  confirm_payment_subtitle: 'Confirm the amount and complete your payment',
  driver_confirm_payment_title: 'Confirm payment',
  driver_confirm_payment_subtitle: 'Check how you get paid and confirm you already received the money',
  payment_method: 'Payment method',
  how_you_get_paid: 'How you get paid',
  pay_mode_cash: 'Cash',
  pay_mode_nequi: 'Nequi',
  pay_mode_bank: 'Bank transfer',
  pay_mode_wallet: 'Wallet',
  pay_mode_card: 'Card',
  driver_pay_hint_cash: 'The passenger pays you in cash. Count the money and confirm only when you have it.',
  driver_pay_hint_nequi: 'The passenger sends you the fare via Nequi. Check your app and confirm only when you see the credit.',
  driver_pay_hint_bank: 'The passenger transfers the fare. Verify the deposit in your account, then confirm.',
  driver_pay_hint_wallet: 'Payment is taken from the passenger wallet. Confirm to close the trip.',
  driver_pay_hint_card: 'The charge is processed by card. Confirm to complete the trip.',
  driver_confirm_received: 'Confirm you received the payment before continuing',
  driver_confirm_cash_btn: 'I confirm I received the cash',
  driver_confirm_nequi_btn: 'I confirm I received the Nequi payment',
  driver_confirm_bank_btn: 'I confirm I received the transfer',
  driver_your_account: 'Your account to receive payment',
  bankName: 'Bank',
  bankAccount: 'Account number',
  bankCode: 'Type / code',
  passenger: 'Passenger',
  amount_to_collect: 'Amount to collect',
  driver_share: 'Your earnings',
  customer_confirm_trip_title: 'Confirm your trip',
  customer_confirm_trip_subtitle_later: 'You agreed on the price. You will pay on arrival with {method}.',
  customer_confirm_trip_subtitle_now: 'Pay now to confirm the driver.',
  offer_accepted: 'Offer accepted',
  agreed_price: 'Agreed price',
  your_offer: 'Your offer',
  customer_pay_hint_cash: 'You will pay the driver in cash at the end of the trip.',
  customer_pay_hint_nequi: 'You will send the Nequi payment at the end of the trip.',
  customer_pay_hint_bank: 'You will make the bank transfer at the end of the trip.',
  customer_pay_hint_wallet: 'It will be deducted from your wallet when you confirm.',
  customer_pay_hint_card: 'It will be charged to your card when you confirm.',
  customer_confirm_cash_btn: 'Confirm trip · Cash on arrival',
  customer_confirm_nequi_btn: 'Confirm trip · Nequi on arrival',
  customer_confirm_bank_btn: 'Confirm trip · Transfer on arrival',
  customer_confirm_pay_now_btn: 'Pay and confirm trip',
  vehicle_arrived_title: 'Your vehicle has arrived',
  vehicle_arrived_hint: 'Identify it by plate, brand and color before you get in.',
  vehicle_color: 'Color',
  vehicle_color_required: 'Vehicle color is required.',
  vehicle_make: 'Brand',
  vehicle_model: 'Model',
  vehicle_number: 'Plate',
  registration_card: 'Registration card',
  upload_registration_image: 'Upload a photo of the registration card',
  registration_image_required: 'You must upload the registration card image.',
  view_registration: 'Registration document',
  car_photo_tip: 'Upload clear photos of your vehicle',
  registration_photo_tip: 'Upload a clear photo of the registration card',
  verify_id: 'ID / Cédula document number',
  verifyid_image: 'ID / Cédula document image',
  upload_verifyIdImage: 'Upload your ID / Cédula document image',
  verified_badge: 'Verified',
  driver_arriving_title: 'Your driver is arriving',
  driver_arriving_msg: 'Get ready, your driver is less than a minute away.',
  arrival_horn_setting: 'Driver arrival sound',
  arrival_horn_setting_hint: 'Horn when your driver is less than a minute away',
  id_verify_optional_hint:
    'Verification is optional. If you are verified you can take part in bonuses, promotions and gifts on Conecta2. You can request trips without verifying.',
  id_verify_driver_required_hint:
    'You must upload your ID / cédula document to operate as a driver.',
  documents_menu_subtitle:
    'If you are verified you can take part in bonuses, promotions and gifts on Conecta2.',
  driving_license_font: 'Driving license front',
  driving_license_back: 'Driving license back',
  upload_driving_license: 'Upload your driving license',
  upload_driving_license_front: 'Upload the front of your driving license',
  upload_driving_license_back: 'Upload the back of your driving license',
  documents: 'Documents',

  // Terms & Privacy — identity verification (Colombia)
  term_condition_heading13: 'Identity verification and documents (optional):',
  term_condition_para15:
    'Identity verification is optional for passengers. Conecta2 may request your identity document number (national ID / cédula or another valid document) and an image or photograph of that document. If you choose to upload such data, you represent that it is true, belongs to you, and you authorize its processing to verify your identity, prevent fraud, comply with internal security policies and, where applicable, enable benefits linked to a verified account (for example, bonuses, promotions or gifts). Verifying your document is not required to request trips. Verification is an internal platform process and does not constitute official authentication before government entities, nor does it replace governmental procedures.',
  term_condition_para16:
    'Conecta2 may approve, reject, or request that you upload the document again. If rejected, the reason will be shown to you in the app. Use of false, altered or third-party documents may result in suspension or termination of your account, without prejudice to any legal actions that may apply. For drivers, when required by the platform, uploading the document may be a condition to operate. Processing of these data is also governed by our Privacy Policy.',
  term_condition_para12:
    'These Terms and Conditions shall be governed by and construed in accordance with the laws of the Republic of Colombia. Any dispute shall be submitted to the competent courts of the Service provider’s domicile in Colombia, without prejudice to mandatory consumer-protection rules that may apply.',

  privacy_policy_heading_id_docs: 'IDENTITY DOCUMENT VERIFICATION',
  privacy_policy_id_docs_para1:
    'Optionally for passengers (and when required by Service settings for drivers), we collect and process: (i) your identity document number (national ID / cédula or another valid document); and (ii) the image or photograph of the document you upload in the app. These data are used to verify that the information matches, validate your identity, prevent fraud, protect the Conecta2 community, decide approval or rejection of verification and, where applicable, enable benefits such as bonuses, promotions or gifts linked to a verified account. It is not required for passengers in order to request trips.',
  privacy_policy_id_docs_para2:
    'The legal basis for processing is your consent when uploading the document and/or performance of the contractual relationship with the platform. Access to the image and number is restricted to authorized Conecta2 staff responsible for review. We do not publish your document to other users and we do not use it for marketing.',
  privacy_policy_id_docs_para3:
    'We retain these data while your account is active and for any additional period needed to meet legal obligations, resolve disputes, or prevent abuse. You may update or re-upload your document from the app. If verification is rejected, the reason will be shown so you can correct it.',
  privacy_policy_id_docs_para4:
    'Under Colombia’s Law 1581 of 2012 and related rules (habeas data), you may request access, update, rectification or deletion of your personal data, and report improper use, through the contact channels in this policy. Deleting the image or document number may limit or prevent features that require identity verification.',
  privacy_policy_heading_rights: 'DATA SUBJECT RIGHTS (HABEAS DATA)',
  privacy_policy_rights_para1:
    'As a data subject in Colombia, you have the right to know, update and rectify your information; to request proof of authorization; to be informed about the use of your data; to file complaints with the Superintendence of Industry and Commerce; and to revoke authorization and/or request deletion of your data when applicable, unless a legal or contractual duty prevents deletion. To exercise these rights, contact us at the email below.',
  privacy_policy_info_list8: 'Identity document number (national ID / cédula or another valid document)',
  privacy_policy_info_list9: 'Image or photograph of the identity document uploaded for verification',
  privacy_policy_info_para3:
    'We may also collect sensitive or identification information when you use or sign up on our App, including data needed for identity verification described in the “Identity document verification” section.',
  privacy_policy_change_privacy_para2: 'This policy is effective as of 2026-10-12.',

  creating_new_request: 'Creating a new request…',
  request_no_longer_available: 'This request is no longer available. Another driver took it or the rider cancelled.',
  request_timeout_message: 'Search timed out. No driver found. Want to try again?',
  car_rejected: 'Rejected',
  car_rejected_title: 'Vehicle rejected',
  car_rejected_hint: 'Fix what was requested and submit again for approval.',
  car_resubmit: 'Resubmit for approval',
  car_reject: 'Reject',
  car_approve: 'Approve',
  car_reject_title: 'Reject vehicle',
  car_reject_pick_reason: 'Choose the rejection reason',
  car_reject_other_placeholder: 'Describe the reason…',
  car_reject_confirm: 'Confirm rejection',
  got_it: 'Got it',
  customer_otp_title: 'Trip code',
  customer_otp_hint: 'Tell this code to the driver to start the trip.',
  payment_error: "The payment couldn't be processed. Please try again.",
  error: 'Error',
  conversion_error: "The account type couldn't be changed. Please try again.",
  error_boundary_message: 'The app hit an unexpected error. If it keeps happening, close it and open it again.',
  retry: 'Retry',

  reg_error: "The sign-up couldn't be completed. Please try again.",
  signup_err_slots_full: "There are no special slots left in this city. Sign up with a driver's referral code.",
  signup_err_network_slots_full: 'Your sponsor has already used all 50 direct slots.',
  signup_err_network_level: "This driver is on level 3 and can't invite more drivers to the network.",
  signup_err_city_mismatch: "Your city must match your sponsor's city.",
  signup_err_referrer_not_found: "We couldn't find the sponsor for that code.",
  signup_err_city_code_required: "Enter your city's zoning code.",
  signup_err_referral_code_required: "Enter a driver's referral code.",
  signup_err_city_required: 'Select your city.',
  signup_err_city_inactive: "This city isn't open for sign-ups right now.",
  signup_err_invalid_code: "That code isn't valid for this city.",
  signup_err_code_used: 'This code has already been used.',
  signup_err_claim_failed: "We couldn't reserve your slot. Please try again.",
  signup_err_city_code_needs_driver: 'That is a city code. You must register as a Driver.',
  signup_err_city_code_needs_city: 'That is a city code. Select the correct city (e.g. Barranquilla) and try again.',
  join_conecta2: 'Join Conecta2',
  city: 'City',
  admin_contact_hint: 'Your account is under review. We will notify you when it is ready.',
  city_not_operational_for_drivers:
    'This city is not operational for drivers yet.',
  city_not_operational_for_drivers_named:
    '{{city}} is not operational for drivers yet.',
  convert_need_city_in_profile:
    'To switch to driver, first edit which city you are in on your profile',
  edit_profile: 'Edit profile',
  city_coming_soon_operational:
    'We will soon be operational in this city.',
  select_city_placeholder: 'Select your city',
  select_city_first: 'Select your city first',
  city_label: 'City',
  zoning_code_placeholder: 'Zoning code',
  no_cities_configured: 'No cities set up yet',
  admin_must_create_cities: 'The administrator needs to create cities in Zoning.',
  city_slots_full_hint: "No special slots left: use a driver's referral code.",
  city_slots_open_hint: "Special slots open: enter your city's master or individual code.",

  offer_not_available: 'This offer is no longer available. Choose another one.',
  tap_to_offer: 'Tap for map and offer',
  go_to_pickup: 'GO TO PICKUP',
  driver_journey_msg_started: 'The trip has started, buckle up',
  driver_cancelled_booking_: 'Driver cancelled the service',
  driver_cancelled_booking: 'Driver cancelled the service',
  driver_cancelled_booking_detail: 'The driver cancelled the service. You can request another trip.',
  customer_cancelled_booking_: 'Passenger cancelled the service',
  customer_cancelled_booking: 'Passenger cancelled the service',
  customer_cancelled_booking_detail: 'The passenger cancelled the service. You should not continue this trip.',
  rider_cancel_text: 'Passenger cancelled the service',
  request_timeout_reason: 'Request timed out',
  request_timeout_reason_: 'Request timed out',
  request_timeout_message: "Time's up. We couldn't find a driver. Do you want to try again?",
  try_again: 'Try again',
  try_again_cta: 'Retry',
  exit: 'Exit',
  retry_booking_failed: "Couldn't request the trip again. Try from the map.",
  tiempo_de_espera_agotado_: 'Request timed out',
  CANCELLED: 'Cancelled',
  COMPLETE: 'Completed',
  PAID: 'Paid',
  NEW: 'New',
  ACCEPTED: 'Accepted',
  no_name: 'No name',
  no_driver_assigned: 'No driver assigned',
  driver: 'Driver',
  trip_pin_title_start: 'Code to start the trip',
  trip_pin_title_end: 'Code to finish the trip',
  trip_pin_subtitle: 'Ask the passenger for the {{digits}}-digit code shown in their app.',
  trip_pin_wrong: 'Wrong code. Check it with the passenger.',
  trip_pin_ok: 'Code verified',
  trip_pin_verify: 'VERIFY',
  trip_pin_cancel: 'Cancel',
  trip_pin_security: 'This code confirms you are carrying the right passenger.',

  // Driver earnings
  daily: 'Daily',
  thisweek: 'This week',
  thismonth: 'This month',

  app_logs: 'Logs',
  loading_maps: 'Loading maps...',
  settings_not_found: "Settings couldn't be loaded. Reload the page.",
  driver_assigned_notified: 'Driver assigned and notified.',

  no_address: "You don't have saved addresses.",
  no_complain: 'No complaints yet.',

  // Existen en español pero no en inglés
  sponsor_column: 'Sponsor',
  sponsor_label: 'Sponsor',
  Time_register: 'Registration date',
  comission_withdraws_web: 'Referral bonus',
  My_referrals: 'My referrals',
  My_Referrals: 'My referrals',
  Referral_bonus: 'Referral bonus',
  codigo_master: 'Master code',
  referrals_refresh_tooltip: 'Refresh referrals',
  sponsor_or_master_hint: "Referred users show their sponsor's name; users without an invitation code appear under MASTER CODE.",
  no_referrals_yet: "You don't have referrals yet",
  Withdrawrefer_title: 'BONUS WITHDRAWAL',
  concept: 'Concept',
  recovering_notifications: 'Recovering notifications',
  recovery_in_progress: 'Recovery in progress',
  force_recovery: 'Force recovery',
  notifications_recovered_title: 'Notifications recovered',
  notifications_recovered_message: 'We detected and fixed a problem with your notifications. You should now receive every message.',
  view_details: 'View details',
  bonus: 'My earnings',
  bonus_history: 'History',
  confirm_arrival: 'CONFIRM ARRIVAL',
  active: 'Active',
  active_booking_right_now: 'Location always on',
  light: 'Light',
  dark: 'Dark',
  system: 'System default',
  PICKUP_USER: 'PICK UP USER',
  email_or_mobile_issue: 'Please check your email or mobile number. Note: Mobile number should be in international format (+57).',
  network_error_retry: 'Could not connect to the server. Please check your internet connection and try again.',
};

export const fallbackTranslations = { es, en };

/** Diccionario completo de un idioma: respaldo local + base de datos (la base de datos gana). */
export const withFallbackTranslations = (langLocale, keyValuePairs) => {
  const base = fallbackTranslations[langLocale] || (String(langLocale || '').startsWith('es') ? es : en);
  const merged = { ...base };
  Object.keys(keyValuePairs || {}).forEach((k) => {
    const v = keyValuePairs[k];
    if (v !== undefined && v !== null && String(v).trim() !== '') merged[k] = v;
  });
  return merged;
};
